import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { LoadingService } from 'src/app/core/services/loader.service';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
})
export class ConfirmationPopupComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  header: string;
  content: string;
  ngOnInit(): void {
    this.header = this.data.header;
    this.content = this.data.content;
    // if (this.data.emailExist && this.data.emailExist == true) {
    //   this.header = 'Email Already Exist!';
    //   this.content =
    //     'As a first time applicant, an email has been sent to ' +
    //     this.data.email +
    //     '. Please follow the prompts to create a password and to continue with the application.';

    //   if (this.data.headerData) {
    //     this.header = this.data.headerData;
    //   }
    // }
    // if (this.data.msg) {

    // }
  }
}
